"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var DropDown_styles_1 = require("../DropDown-styles");
var DropDownHeaderSearchable = function (_a) {
    var disabled = _a.disabled, ghost = _a.ghost, onChange = _a.onChange, searchTerm = _a.searchTerm, title = _a.title, widthCssValue = _a.widthCssValue;
    return (React.createElement(DropDown_styles_1.DropDownSearch, { style: { width: widthCssValue }, disabled: disabled, ghost: ghost },
        React.createElement(DropDown_styles_1.DropDownSearchInput, { id: 't2-dropdown-' + title, "data-id": 't2-dropdown', disabled: disabled, type: "text", autoComplete: "off", placeholder: title, value: searchTerm, onChange: onChange }),
        React.createElement(DropDown_styles_1.DropDownComponentIcon, null)));
};
exports.default = DropDownHeaderSearchable;
